import { SafeJSONParser } from './safe-json-parser'

export const getToken = () => SafeJSONParser(localStorage.getItem('token') || '')?.token
